import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';
import _ from 'lodash';
import moment from 'moment';
import Promise from 'bluebird';
import RCore from 'RCore';

class StagePicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        let stageId = [];
        try {
            const candidate = props[_.get(props, `propsMap.stageId`, 'stageId')];
            if (_.isArray(candidate)) stageId = props[_.get(props, `propsMap.stageId`, 'stageId')];
            else stageId = JSON.parse(props[_.get(props, `propsMap.stageId`, 'stageId')]) || [];
        } catch (e) {
            console.log('err');
        }

        this.state = {
            tournamentId: +props.tournamentId,
            seasonId: +props.seasonId,
            season: {},
            stageId: stageId,
            // all: stageId.length === 0,
            all: false,
        };

        this.loadData();
    }

    componentWillReceiveProps = nextProps => {
        const { tournamentId, seasonId } = this.state;

        if (nextProps.tournamentId !== tournamentId || (nextProps.seasonId && nextProps.seasonId !== seasonId)) {
            this.setState(
                {
                    tournamentId: nextProps.tournamentId,
                    seasonId: nextProps.seasonId,
                    // all: true,
                    all: false,
                    stageId: [],
                },
                () => {
                    this.loadData();
                    // if was changed tournament and stageIds remains not empty (means previous) => reset them
                    this.props.onChange(this.getPropertyFor('stageId'), []);
                },
            );
        }
    };

    getPropertyFor(key) {
        return _.get(this, `props.propsMap[${key}]`, key);
    }

    loadData = () => {
        const { tournamentId, seasonId } = this.state;
        if (!tournamentId) return Promise.resolve({});

        return RCore.promiseProps({
            season: fetch(`${config.apis.ss2}/tournaments/${tournamentId}/seasons?locale=en`)
                .then(response => response.json())
                .then(seasons => {
                    var season = _.find(seasons, s => {
                        if (!seasonId) return s.isCurrent;
                        return s.id === seasonId;
                    });
                    if (!season) season = _.last(seasons);

                    return season;
                }),
        })
            .then(res => {
                const { season } = res;
                const { stageIds } = this.props;
                const currentDate = moment(new Date()).format('YYYY-01-01');

                return RCore.promiseProps({
                    season,
                    stageId: fetch(
                        `${config.apis.ss2}/events-v2?locale=en&seasonId=${season.id}&fromDate=${currentDate}`,
                    )
                        .then(response => response.json())
                        .then(res => res.events)
                        // .then(events => {
                        //     if (!this.props.autoHighlighting) return [];
                        //     const event = _.find(events, ev => ev.properties && ['1/8', '1/4', '1/2'].includes(ev.properties.round));
                        //
                        //     const currentStage = event && event.tournamentStageId ? [event.tournamentStageId] : [];
                        //     const stages = stageIds.length ? stageIds : currentStage;
                        //
                        //     this.props.onChange(this.getPropertyFor('stageId'), stages);
                        //
                        //     return stages;
                        // })
                        .then(() => {
                            const stages = stageIds.length ? stageIds : [];
                            this.props.onChange(this.getPropertyFor('stageId'), stages);

                            return stages;
                        }),
                });
            })
            .then(res => {
                this.setState({
                    ...res,
                });
            })
            .catch(e => {
                console.error(e);
            });
    };

    handleStageCheck = (stId, e, val) => {
        const { stageId, season } = this.state;
        const allStages = season.stages.map(s => s.id);

        this.setState(
            {
                stageId: val ? _.concat(stageId, stId) : _.without(stageId, stId),
            },
            () => {
                if (this.state.stageId.length === 0) {
                    this.setState({ all: true, stageId: allStages });
                    this.props.onChange(this.getPropertyFor('stageId'), allStages);
                } else {
                    this.props.onChange(this.getPropertyFor('stageId'), this.state.stageId);
                }
            },
        );
    };

    render() {
        const { season, stageId, all } = this.state;
        //if (!season || (season.stages && season.stages.length === 1)) return <div />;
        if (!season || !season.stages) return <div />;

        const allStages = season.stages.map(s => s.id);

        return (
            <div>
                <rmd.Toggle
                    label="All stages"
                    toggled={all}
                    onToggle={(e, value) => {
                        if (value) {
                            this.setState({ all: true, stageId: allStages }, () => {
                                this.props.onChange(this.getPropertyFor('stageId'), allStages);
                            });
                        } else {
                            this.setState({ all: false }, () => {
                                this.props.onChange(this.getPropertyFor('stageId'), null);
                            });
                        }
                    }}
                    style={{ marginBottom: '16px' }}
                />
                {_.chain(season.stages || [])
                    .groupBy(st => {
                        return moment(st.startDate).format('MMM YY') + ' - ' + moment(st.endDate).format('MMM YY');
                    })
                    .toPairs()
                    .map(p => {
                        const group = p[0];
                        const stages = p[1];
                        return [
                            <div key={group}>{group}</div>,
                            _.sortBy(stages, st => st.name).map(st => (
                                <rmd.Checkbox
                                    key={st.id}
                                    disabled={all}
                                    checked={stageId.indexOf(st.id) !== -1}
                                    onCheck={this.handleStageCheck.bind(this, st.id)}
                                    label={`${st.name}`}
                                />
                            )),
                        ];
                    })
                    .value()}
            </div>
        );
    }
}

export default StagePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/StagePicker.js
 **/